import { useState } from "react"

const ClickableCell = ({
    value: initialValue,

}) => {
    const [show, setShow] = useState(false);

    const changeViewToFalse = e => {
        e.preventDefault();
        setShow(false);
    }

    const changeViewToTrue = e => {
        e.preventDefault();
        setShow(true);
    }

    return show ?
        <p>
            {initialValue}
            <button onClick={changeViewToFalse}>{` <<`}</button>
        </p> :
        <p>
            <button onClick={changeViewToTrue}>{`>> `}</button>
            ...
        </p>
}

export default ClickableCell